import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  PayrollStartConfig,
  PayrollStartData,
  PayrollStatuses,
  PayDateInfoEx,
  PayTypes,
  MasterPayrollObject
} from '../../../../models/payroll';
import { Router } from '@angular/router';
import { PayrollService } from '../../../../services/payroll.service';
import { InstanceTypes } from '../../../../models/instance-types';
import { IsPayDateInvalid } from '../PaydateValidationFunction';
import { PayrollManagement } from '../../../../tools/payroll-management';
import { ClientSetup } from '../../../../models/client';
import { AppConfigService } from '../../../../services/app-config.service';

@Component({
  selector: 'manual-payroll-tile',
  templateUrl: './manual-payroll-tile.component.html',
  styleUrls: ['./manual-payroll-tile.component.css'],
  standalone: false
})
export class ManualPayrollTileComponent implements OnInit {
  @Input() clientCode: string;
  @Input() clientSetup: ClientSetup;
  @Input() payrollStartData: PayrollStartData;

  public payrollStartConfig: PayrollStartConfig;

  get isSubmitDisabled() {
    return this.payrollStartConfig.IsLocked;
  }

  get isTileDisabled() {
    return (
      this.payrollStartConfig.Unsupported?.length ||
      !this.appConfigService.getConfig().EnableManualPayroll
    );
  }

  constructor(
    private router: Router,
    private payrollService: PayrollService,
    private payrollMgmt: PayrollManagement,
    private appConfigService: AppConfigService,
    @Inject('env') private env: any
  ) {}

  ngOnInit(): void {
    this.payrollStartConfig = this.payrollMgmt.buildPayrollConfig(
      this.clientSetup,
      this.payrollStartData?.ActivePayroll,
      null,
      PayTypes.Manual,
      this.payrollStartData
    );
  }

  //#region Public Methods

  public navigatePayroll() {
    this.payrollMgmt.startResumeManualPayroll(this.clientCode, this.payrollStartData);
  }

  //#endregion

  //#region Private Methods

  //#endregion
}
